module.exports = __webpack_public_path__ + "img/gy.3d053356.png";